import { useState, useEffect, useCallback } from 'react';

/**
 * useCarousel — manages auto-advancing carousel state.
 *
 * @param {number} itemCount  Total number of items in the carousel.
 * @param {number} intervalMs Time in ms between auto-advances (default 3000).
 * @returns {{ currentIndex: number, goToSlide: (index: number) => void }}
 */
const useCarousel = (itemCount, intervalMs = 3000) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-advance through items
  useEffect(() => {
    if (itemCount <= 1) return undefined;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % itemCount);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [itemCount, intervalMs]);

  const goToSlide = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  return { currentIndex, goToSlide };
};

export default useCarousel;
